import { render, staticRenderFns } from "./InternalBannerManagement.vue?vue&type=template&id=1f99da6a&scoped=true"
import script from "./InternalBannerManagement.vue?vue&type=script&lang=js"
export * from "./InternalBannerManagement.vue?vue&type=script&lang=js"
import style0 from "./InternalBannerManagement.vue?vue&type=style&index=0&id=1f99da6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f99da6a",
  null
  
)

export default component.exports